import { createApi } from '@reduxjs/toolkit/query/react';

import type { NetworkListSchemaType } from '@/global/schemas/network.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const networkApi = createApi({
  reducerPath: REDUX_SLICE.NETWORK_API,
  tagTypes: ['Networks'],
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    fetchNetworks: builder.query<NetworkListSchemaType, void>({
      query: () => ({
        path: `v1/networks`,
        params: { filter: JSON.stringify({ version: 3 }) },
      }),
      transformResponse: (returnValue: NetworkListSchemaType) => returnValue,
      providesTags: (_result, _error) => [{ type: 'Networks' }],
    }),
  }),
});

export const { useFetchNetworksQuery } = networkApi;
